/****************************************************************************
 * Copyright 2021 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/

export const NucleotideAvatar = () => (
  <>
    <symbol id="nucleotide" viewBox="0 0 84 84" width="42" height="42">
      <path
        className="monomer-body"
        data-actual-width="42"
        data-actual-height="42"
        d="M43.0152 71.4019C42.3887 71.771 41.6113 71.771 40.9848 71.4019L9.25584 52.7093C8.50744 52.2684 8.1292 51.3948 8.31974 50.5473L16.6358 13.5613C16.841 12.6485 17.6516 12 18.5871 12L65.4129 12C66.3484 12 67.159 12.6485 67.3642 13.5613L75.6803 50.5473C75.8708 51.3948 75.4926 52.2684 74.7442 52.7093L43.0152 71.4019Z"
        transform="rotate(180, 42, 42)"
      />
    </symbol>
    <symbol id="nucleotide-hover" viewBox="0 0 84 84" width="42" height="42">
      <path
        data-actual-width="42"
        data-actual-height="42"
        d="M43.0152 71.4019C42.3887 71.771 41.6113 71.771 40.9848 71.4019L9.25584 52.7093C8.50744 52.2684 8.1292 51.3948 8.31974 50.5473L16.6358 13.5613C16.841 12.6485 17.6516 12 18.5871 12L65.4129 12C66.3484 12 67.159 12.6485 67.3642 13.5613L75.6803 50.5473C75.8708 51.3948 75.4926 52.2684 74.7442 52.7093L43.0152 71.4019Z"
        transform="rotate(180, 42, 42)"
        fill="none"
        stroke="#0097A8"
        strokeWidth="3"
      />
    </symbol>
    <symbol
      id="nucleotide-autochain-preview"
      viewBox="0 0 36 32"
      width="36"
      height="32"
      data-actual-width="36"
      data-actual-height="32"
    >
      <path d="M20.3771 2.38574L18.5929 1.0722C18.2402 0.812609 17.7598 0.812609 17.4071 1.0722L15.6229 2.38574M32.6021 11.3857L34.4405 12.7392C34.7769 12.9868 34.9239 13.4174 34.8092 13.8191L34.2725 15.6985M3.39787 11.3857L1.55948 12.7392C1.2231 12.9868 1.07608 13.4174 1.19078 13.8191L1.72751 15.6985M30.8088 27.8266L30.2138 29.9168C30.0914 30.3466 29.6988 30.643 29.252 30.643H27.0063M5.19116 27.8266L5.7931 29.9194C5.91633 30.3479 6.30831 30.643 6.75414 30.643H9.00194" />
      <path d="M10.5017 30.6426L13.5017 30.6426" />
      <path d="M16.5032 30.6426L19.5032 30.6426" />
      <path d="M22.5046 30.6426L25.5046 30.6426" />
      <path d="M2.23663 17.4971L3.06363 20.3808" />
      <path d="M3.83911 23.0859L4.66611 25.9697" />
      <path d="M22.356 3.85059L25.5765 6.22306" />
      <path d="M27.5099 7.64746L30.7304 10.0199" />
      <path d="M13.605 3.85156L10.3846 6.22404" />
      <path d="M8.45105 7.64844L5.23059 10.0209" />
      <path d="M33.7705 17.4971L32.9435 20.3808" />
      <path d="M32.168 23.0859L31.341 25.9697" />
    </symbol>
  </>
);
